/**
 * Auto-generated barrel - DO NOT EDIT MANUALLY
 * Run: pnpm gen
 *
 * Binds every generated Compass API service to the dashboard's transport (an axios
 * adapter over the existing apiClient, so token refresh, retries, toasts and logout
 * redirects all still apply). Import services from '@services/api'.
 */

import { createServices } from '@compass/client';
import { transport } from '@services/api.config';

export const {
  analyticsService,
  appAnalyticsEventsService,
  assetService,
  auditService,
  authService,
  callService,
  campaignService,
  caseRecordService,
  casesAnalyticsService,
  dispositionService,
  drugService,
  eligibilityService,
  emailService,
  evaluationService,
  faxService,
  feedbackInsightService,
  feedbackService,
  genericTaskService,
  ingestionService,
  intentService,
  mailboxService,
  manualActionService,
  manualTaskService,
  membershipService,
  metadataRegistryService,
  noteService,
  organizationRoleService,
  organizationService,
  organizationTeamService,
  organizationUserService,
  orgKeyService,
  payorService,
  phoneNumberService,
  pmsService,
  policyService,
  programRoleService,
  programService,
  programTeamService,
  programUserService,
  roleService,
  schemaService,
  scorecardService,
  scriptService,
  serviceAccountService,
  summaryService,
  teamService,
  templateService,
  textService,
  userService,
  webhookService,
  workflowService,
} = createServices(transport);
